// Function useful for filtering arrays to non nullable values while keeping TS happy
// Alternative to .filter(Boolean) which causes TS complaints
export function nonNullable(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=index.js.map